import { ChangeDetectorRef, Component, Inject, OnDestroy, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { FormControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { finalize, takeUntil } from 'rxjs/operators';

import { PositionGroupModel } from 'projects/workspace/src/app/shared/models';
import { DangerModalComponent } from '../danger-modal/danger-modal.component';
import { CommonModalsActionsEnum } from '../common-modals-actions.enum';

type SubmitRequestFn = (groupName: string) => Observable<PositionGroupModel>;
type DeleteRequestFn = () => Observable<null>;

@Component({
  selector: 'rnpl-position-group-modal',
  templateUrl: './position-group-modal.component.html',
})
export class PositionGroupModalComponent implements OnDestroy {

  public groupNameControl: FormControl = new FormControl(null, [Validators.required]);

  @ViewChild('editor', {static: false}) public editorRef;

  readonly destroy$: Subject<void> = new Subject();
  readonly submitRequest$: BehaviorSubject<boolean> = new BehaviorSubject(null);

  constructor(
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    public dialogRef: MatDialogRef<PositionGroupModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      group?: PositionGroupModel;
      submitRequest$: SubmitRequestFn;
      deleteRequest$: DeleteRequestFn;
    }
  ) {
    if (this.data.group && this.data.group.name) {
      this.groupNameControl.patchValue(this.data.group.name, {emitEvent: false});
    }
  }

  public deleteGroup(): void {
    const dialog = this.dialog.open(DangerModalComponent, {
      data: {
        title: 'POSITIONS_GROUPING.REMOVE_MODAL_TTL',
        message: 'POSITIONS_GROUPING.REMOVE_MODAL_MSG',
        confirmBtnText: 'BUTTON.DELETE',
        confirmBtnIcon: 'trash-2'
      }
    });

    dialog.afterClosed().subscribe((res: CommonModalsActionsEnum) => {
      if (res === CommonModalsActionsEnum.CONFIRM) {
        this.data.deleteRequest$()
          .pipe(
            finalize(() => this.submitRequest$.next(false)),
            takeUntil(this.destroy$)
          )
          .subscribe(() => this.dialogRef.close(CommonModalsActionsEnum.CONFIRM));
      }
    });
  }

  public submit(): void {
    this.groupNameControl.markAsTouched();
    this.groupNameControl.updateValueAndValidity();

    if (this.groupNameControl.invalid) {
      this.cdr.detectChanges();
      this.editorRef.resetTextContent('');
      return;
    }

    if (this.submitRequest$.getValue()) { return; }
    this.submitRequest$.next(true);

    this.data.submitRequest$(this.groupNameControl.value)
      .pipe(
        finalize(() => this.submitRequest$.next(false)),
        takeUntil(this.destroy$)
      )
      .subscribe(() => this.dialogRef.close(CommonModalsActionsEnum.CONFIRM));
  }

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }

}

